import React from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import moment from 'moment'

import { EventCard } from '../EventCard'
import { SectionBlock } from '../SectionBlock'

import { useStyles } from './UpcomingEventsSection.style'

const UpcomingEventsSection = ({ altMode }) => {
  const classes = useStyles()

  const { championship } = useSelector((state) => state.championships)
  const { events } = championship

  const upcomingEvents = events
    .filter((x) => moment(x.to).isSameOrAfter(moment()))
    .sort(
      (a, b) =>
        moment(a.from).diff(moment(b.from)) ||
        a.name.toLowerCase().trim().localeCompare(b.name.toLowerCase().trim())
    )

  return (
    !!upcomingEvents.length && (
      <SectionBlock
        title='Eventos Próximos'
        className={clsx(classes.container, altMode && classes.altSection)}>
        <div className={classes.eventsContainer}>
          {upcomingEvents.map((e) => (
            <EventCard key={e.id} event={e} altMode={altMode} />
          ))}
        </div>
      </SectionBlock>
    )
  )
}

export default UpcomingEventsSection
